import { render, staticRenderFns } from "./epmallorderitem.vue?vue&type=template&id=09d02f49"
import script from "./epmallorderitem.vue?vue&type=script&lang=js"
export * from "./epmallorderitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports